import React from "react";
import { Check, Zap, Clock } from "lucide-react";
import { GHS } from "@/lib/api";

export const PlanCard = ({ plan, onSelect, ctaLabel = "SELECT PLAN", compact = false }) => {
  const isTime = plan.type === "time_pass";
  const benefit = isTime
    ? `Unlimited analyses for ${plan.duration_hours >= 24 ? `${plan.duration_hours / 24} day${plan.duration_hours > 24 ? "s" : ""}` : `${plan.duration_hours}h`}`
    : `${plan.credits} screenshot ${plan.credits > 1 ? "analyses" : "analysis"}`;
  const features = isTime
    ? ["Unlimited screenshot analyses", `Expires exactly ${plan.duration_hours}h after activation`, "Top 3 strongest selections", "Full prediction history"]
    : [`${plan.credits} successful ${plan.credits > 1 ? "analyses" : "analysis"}`, "Credit used only on success", "Top 3 strongest selections", "Full prediction history"];

  return (
    <div
      className={`relative flex flex-col ${plan.popular ? "vw-glow-card" : "vw-card"} p-6 sm:p-7`}
      data-testid={`plan-card-${plan.name.toLowerCase().replace(/\s/g, "-")}`}
      style={plan.popular ? { borderColor: "rgba(0,255,102,0.5)" } : {}}
    >
      {plan.popular && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full text-[11px] font-bold font-mono uppercase tracking-wider"
          style={{ background: "linear-gradient(90deg,#10B981,#00FF66)", color: "#04210F" }}>
          Most Popular
        </span>
      )}
      <div className="flex items-center gap-2 text-emerald-400">
        {isTime ? <Clock size={18} /> : <Zap size={18} />}
        <h3 className="font-display text-lg font-bold text-white">{plan.name}</h3>
      </div>
      <div className="mt-4 flex items-end gap-1.5">
        <span className="font-display text-4xl font-black text-white">{GHS(plan.price)}</span>
      </div>
      <p className="mt-1.5 text-sm text-emerald-400 font-semibold">{benefit}</p>
      {!compact && <p className="mt-2 text-sm text-slate-400 leading-relaxed">{plan.tagline}</p>}

      <ul className="mt-5 space-y-2.5 flex-1">
        {features.map((f, i) => (
          <li key={i} className="flex items-start gap-2.5 text-sm text-slate-300">
            <Check size={16} className="text-emerald-400 mt-0.5 shrink-0" /> {f}
          </li>
        ))}
      </ul>

      <button onClick={() => onSelect(plan)}
        className={`mt-6 w-full ${plan.popular ? "vw-btn-primary" : "vw-btn-outline"} !py-3`}
        data-testid={`select-plan-${plan.name.toLowerCase().replace(/\s/g, "-")}`}>
        {ctaLabel}
      </button>
    </div>
  );
};
